import { artBoardActions } from '@store/reducers/artboard'
import { showComments } from '@storeOld/reducers/comments'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { useArtboardMode } from '@/hooks'
import { clsJoin } from '@/utils'
import type { ThreadListItem } from '../../types'
import { LinkFooter } from '../LinkFooter'
import { LinkHeader } from '../LinkHeader'
import { ThreadBody } from '../ThreadBody'
import css from './styles.module.css'

interface Props {
  thread: ThreadListItem
}

export const ThreadLink: React.FC<Props> = ({ thread }) => {
  const dispatch = useDispatch()
  const { newThread } = useArtboardMode()

  // A pin opens on the canvas; a block or a page first brings its page into
  // view, then opens the same modal the counter on the card opens. Picking an
  // existing thread ends placing a new one: the crosshair stayed on and kept
  // taking the pointer over the canvas. The panel stays open.
  const onClick = () => {
    if (newThread) {
      dispatch(artBoardActions.changeMode('edit'))
    }

    if (thread.kind === 'thread') {
      dispatch(artBoardActions.jumpToThread(thread))
      return
    }

    if (thread.pageId) {
      dispatch(artBoardActions.jumpToPage({ id: thread.pageId }))
    }

    // @ts-expect-error the legacy thunk is untyped
    dispatch(showComments(thread.id, thread.kind === 'page' ? 'node' : 'block'))
  }

  const className = clsJoin(
    css.thread_link,
    thread.active && css.active,
    thread.resolved && css.resolved
  )

  return (
    <div onClick={onClick} className={className}>
      <LinkHeader thread={thread} actionsClassName={css.actions} />
      <ThreadBody content={thread.content} />
      <LinkFooter thread={thread} />
    </div>
  )
}
